import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  setCredentials,
  resetReducer,
  setAuthError,
} from "../../features/auth/authSlice";
import Url from "../../global";
// import { useSelector } from "react-redux";

const baseQuery = fetchBaseQuery({
  baseUrl: Url,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    // console.log("fetchBaseQuery: getState():  ", getState());
    const token = getState().auth.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

let refreshPromise = null;

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.originalStatus === 403) {
    if (!refreshPromise) {
      refreshPromise = (async () => {
        try {
          const refreshResult = await baseQuery("/refresh", api, extraOptions);
          if (refreshResult?.data) {
            api.dispatch(setCredentials({ ...refreshResult.data }));
            return true;
          } else {
            api.dispatch(resetReducer());
            api.dispatch({ type: "api/resetApiState" });
            api.dispatch(setAuthError("Session expired. Please login again."));
            return false;
          }
        } catch (e) {
          return false;
        } finally {
          refreshPromise = null;
        }
      })();
    }

    const success = await refreshPromise;
    if (success) {
      result = await baseQuery(args, api, extraOptions);
    }
  }

  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  // keepUnusedDataFor: 0,
  tagTypes: [
    "User",
    "Guru",
    "Siswa",
    "Kelas",
    "Absensi",
    "EkstrakurikulerType",
    "EkstrakurikulerGradeDescription",
    "IsiRaport",
    "Sumatif",
    "Formatif",
    "Ekskul",
    "CatatanGuru",
    "UserTU",
    "UserCS",
    "LogActivity",
    "MenuActivity",
    "Informasi",
    "KokurikulerGradeDescription",
    "Kurikuler",
    "KokurikulerRef",
    "KokurikulerPaud",
    "EkstrakurikulerPaudAcuan",
    "CapaianPaudAcuan",
    "CapaianPaud",
    "TujuanPembelajaran",
    "MataPelajaran",
    "RoleDetail",
    "MapelDetail",
    "RekapNilai",
    "RekapNilaiTengahSemester",
    "RekapNilaiWakur",
    "Sikap",
    "School",
    "HasilRaport",
    "DetailRaport",
    "WalasRaporFoto",
    "Organization",
    "UserGuru",
    "UserGuruDetails",
    "Tabungan",
  ],
  endpoints: (builder) => ({}),
});
